import { useRef } from 'react';

import styles from './MessageContent.module.css';
import { useScrollText } from '../../hooks/useScrollText';
import { useTicker } from './useTicker';

export const MessageContent = ({
  content,
  setDelay,
  msgId,
  contentContainerRef,
}) => {
  const contentRef = useRef();
  const { animatedPositionX, scrollSpeed, scrollDelayStart } = useScrollText(
    contentRef,
    contentContainerRef,
    msgId,
    setDelay
  );

  useTicker({
    startDelay: scrollDelayStart,
    msgId,
    scrollSpeed,
    animatedPositionX,
    contentRef,
  });

  return (
    <div className={styles.content} ref={contentRef}>
      {content}
    </div>
  );
};
